import * as React from 'react';
import { Context } from 'react';

type DataMessageType = 'message' /* | 'broadcast' | 'chat'; */; // messages can be 'broadcast' or 'chat' in the future...
type ShareSDKComposerVersion = 'share_sdk';

export type UIEventContext = {
  message_type: string;
  is_urgent: boolean;
  composer_version: ShareSDKComposerVersion;
};

export type ComposerContextType = {
  isUrgentMessage: boolean;
  messageType: DataMessageType;
  getUIEventContext: () => UIEventContext;
};

export const ComposerContext: Context<ComposerContextType> =
  React.createContext<ComposerContextType>({
    isUrgentMessage: false,
    messageType: 'message',
    getUIEventContext: function () {
      return {
        message_type: this.messageType,
        is_urgent: this.isUrgentMessage,
        composer_version: 'share_sdk',
      };
    },
  });
